import { type BaseItem } from './common.js';
import {
  type HasEhrInformationId,
  type HasEncounterId,
  type HasEntityIdPartial,
  type HasPatientOrderId,
} from './entityId.js';
import * as Billing from './workflow/billing.js';
import * as ExportAllergies from './workflow/exportAllergies.js';
import * as ExportAppointmentNote from './workflow/exportAppointmentNote.js';
import * as ExportAppointmentStatus from './workflow/exportAppointmentStatus.js';
import * as ExportAuthorizationForm from './workflow/exportAuthorizationForm.js';
import * as ExportAuthorizationStart from './workflow/exportAuthorizationStart.js';
import * as ExportAuthorizationStatus from './workflow/exportAuthorizationStatus.js';
import * as ExportAuthorizationSubmission from './workflow/exportAuthorizationSubmission.js';
import * as ExportCareGapFindings from './workflow/exportCareGapFindings.js';
import * as ExportChargeReview from './workflow/exportChargeReview.js';
import * as ExportClinicalComment from './workflow/exportClinicalComment.js';
import * as ExportEncounterInformation from './workflow/exportEncounterInformation.js';
import * as ExportFamilyMedicalHistory from './workflow/exportFamilyMedicalHistory.js';
import * as ExportFinancialResponsibility from './workflow/exportFinancialResponsibility.js';
import * as ExportFollowUp from './workflow/exportFollowUp.js';
import * as ExportForms from './workflow/exportForms.js';
import * as ExportGeneralComment from './workflow/exportGeneralComment.js';
import * as ExportGuarantor from './workflow/exportGuarantor.js';
import * as ExportHccFindings from './workflow/exportHccFindings.js';
import * as ExportMarkAsReviewed from './workflow/exportMarkAsReviewed.js';
import * as ExportMedications from './workflow/exportMedications.js';
import * as ExportNewEncounter from './workflow/exportNewEncounter.js';
import * as ExportNoteCheckedIn from './workflow/exportNoteCheckedIn.js';
import * as ExportNoticeOfAdmission from './workflow/exportNoticeOfAdmission.js';
import * as ExportNoticeOfAdmissionStatus from './workflow/exportNoticeOfAdmissionStatus.js';
import * as ExportOrderRequestListStatus from './workflow/exportOrderRequestListStatus.js';
import * as ExportPatientCareProviders from './workflow/exportPatientCareProviders.js';
import * as ExportPatientInformation from './workflow/exportPatientInformation.js';
import * as ExportPatientInsuranceInformation from './workflow/exportPatientInsuranceInformation.js';
import * as ExportPatientMedicalHistory from './workflow/exportPatientMedicalHistory.js';
import * as ExportPatientPharmacies from './workflow/exportPatientPharmacies.js';
import * as ExportPatientUploadStatuses from './workflow/exportPatientUploadStatuses.js';
import * as ExportPatientUploads from './workflow/exportPatientUploads.js';
import * as ExportPayorAuthorization from './workflow/exportPayorAuthorization.js';
import * as ExportPreregistrationEncounter from './workflow/exportPreregistrationEncounter.js';
import * as ExportProcessedPayments from './workflow/exportProcessedPayments.js';
import * as ExportRegistrationNote from './workflow/exportRegistrationNote.js';
import * as ExportScheduledAppointment from './workflow/exportScheduledAppointment.js';
import * as ExportScheduledOrderAssociation from './workflow/exportScheduledOrderAssociation.js';
import * as ExportSocialHistory from './workflow/exportSocialHistory.js';
import * as ExportSurgicalHistory from './workflow/exportSurgicalHistory.js';
import * as ExportTerminatedInsurances from './workflow/exportTerminatedInsurances.js';
import * as ExportVerifyRegistration from './workflow/exportVerifyRegistration.js';
import * as ExternalDocumentPacket from './workflow/externalDocumentPacket.js';
import * as ExternalOrderPacket from './workflow/externalOrderPacket.js';
import * as ExtractAuthorizationStatus from './workflow/extractAuthorizationStatus.js';
import * as ExtractMedicalNecessity from './workflow/extractMedicalNecessity.js';
import * as ExtractNoticeOfAdmissionStatus from './workflow/extractNoticeOfAdmissionStatus.js';
import * as ExtractPatientAdvisories from './workflow/extractPatientAdvisories.js';
import * as ExtractPatientAdvisoryDocuments from './workflow/extractPatientAdvisoryDocuments.js';
import * as ExtractPatientDocuments from './workflow/extractPatientDocuments.js';
import * as ExtractPatientEligibility from './workflow/extractPatientEligibility.js';
import * as ExtractPatientInsuranceRteInformation from './workflow/extractPatientInsuranceRteInformation.js';
import * as ExtractPatientOrder from './workflow/extractPatientOrder.js';
import * as ExtractPayorAuthorizationStatus from './workflow/extractPayorAuthorizationStatus.js';
import * as Note from './workflow/note.js';
import * as Order from './workflow/order.js';
import * as Previsit from './workflow/previsit.js';
import * as ProblemGroup from './workflow/problemGroup.js';
import * as QualityMeasure from './workflow/qualityMeasure.js';
import * as TrainingSegments from './workflow/trainingSegments.js';

export {
  Billing,
  ExportAllergies,
  ExportAppointmentNote,
  ExportAppointmentStatus,
  ExportAuthorizationForm,
  ExportAuthorizationStart,
  ExportAuthorizationStatus,
  ExportAuthorizationSubmission,
  ExportCareGapFindings,
  ExportChargeReview,
  ExportClinicalComment,
  ExportNewEncounter,
  ExportEncounterInformation,
  ExportFamilyMedicalHistory,
  ExportFinancialResponsibility,
  ExportOrderRequestListStatus,
  ExportFollowUp,
  ExportForms,
  ExportHccFindings,
  ExportGeneralComment,
  ExportGuarantor,
  ExportMarkAsReviewed as ExportMarkAllAsReviewed,
  ExportMedications,
  ExportNoteCheckedIn,
  ExportNoticeOfAdmission,
  ExportNoticeOfAdmissionStatus,
  ExportPatientCareProviders,
  ExportPatientInformation,
  ExportPatientInsuranceInformation,
  ExportPatientMedicalHistory,
  ExportPatientPharmacies,
  ExportPatientUploads,
  ExportPatientUploadStatuses,
  ExportPayorAuthorization,
  ExportPreregistrationEncounter,
  ExportProcessedPayments,
  ExportRegistrationNote,
  ExportScheduledAppointment,
  ExportScheduledOrderAssociation,
  ExportSocialHistory,
  ExportSurgicalHistory,
  ExportTerminatedInsurances,
  ExportVerifyRegistration,
  ExternalDocumentPacket,
  ExternalOrderPacket,
  ExtractAuthorizationStatus,
  ExtractMedicalNecessity,
  ExtractNoticeOfAdmissionStatus,
  ExtractPatientAdvisories,
  ExtractPatientAdvisoryDocuments,
  ExtractPatientDocuments,
  ExtractPatientEligibility,
  ExtractPatientInsuranceRteInformation,
  ExtractPatientOrder,
  ExtractPayorAuthorizationStatus, // DEPRECATED
  Note,
  Order,
  Previsit,
  ProblemGroup,
  QualityMeasure,
  TrainingSegments,
};

export const Kinds = [
  Billing.Kind,
  ExportAllergies.Kind,
  ExportAppointmentNote.Kind,
  ExportAppointmentStatus.Kind,
  ExportAuthorizationForm.Kind,
  ExportAuthorizationStart.Kind,
  ExportAuthorizationStatus.Kind,
  ExportAuthorizationSubmission.Kind,
  ExportCareGapFindings.Kind,
  ExportChargeReview.Kind,
  ExportClinicalComment.Kind,
  ExportNewEncounter.Kind,
  ExportEncounterInformation.Kind,
  ExportFamilyMedicalHistory.Kind,
  ExportFinancialResponsibility.Kind,
  ExportFollowUp.Kind,
  ExportForms.Kind,
  ExportGeneralComment.Kind,
  ExportGuarantor.Kind,
  ExportHccFindings.Kind,
  ExportMarkAsReviewed.Kind,
  ExportMedications.Kind,
  ExportNoteCheckedIn.Kind,
  ExportNoticeOfAdmission.Kind,
  ExportNoticeOfAdmissionStatus.Kind,
  ExportOrderRequestListStatus.Kind,
  ExportPatientCareProviders.Kind,
  ExportPatientInformation.Kind,
  ExportPatientInsuranceInformation.Kind,
  ExportPatientMedicalHistory.Kind,
  ExportPatientPharmacies.Kind,
  ExportPatientUploads.Kind,
  ExportPatientUploadStatuses.Kind,
  ExportPayorAuthorization.Kind,
  ExportPreregistrationEncounter.Kind,
  ExportProcessedPayments.Kind,
  ExportRegistrationNote.Kind,
  ExportScheduledAppointment.Kind,
  ExportScheduledOrderAssociation.Kind,
  ExportSocialHistory.Kind,
  ExportSurgicalHistory.Kind,
  ExportTerminatedInsurances.Kind,
  ExportVerifyRegistration.Kind,
  ExternalDocumentPacket.Kind,
  ExternalOrderPacket.Kind,
  ExtractAuthorizationStatus.Kind,
  ExtractMedicalNecessity.Kind,
  ExtractNoticeOfAdmissionStatus.Kind,
  ExtractPatientAdvisories.Kind,
  ExtractPatientAdvisoryDocuments.Kind,
  ExtractPatientDocuments.Kind,
  ExtractPatientEligibility.Kind,
  ExtractPatientInsuranceRteInformation.Kind,
  ExtractPatientOrder.Kind,
  Note.Kind,
  Order.Kind,
  Previsit.Kind,
  ProblemGroup.Kind,
  QualityMeasure.Kind,
  TrainingSegments.Kind,
] as const;

export type Kind = (typeof Kinds)[number];

export type Status<TKind extends Kind = Kind> = {
  [Billing.Kind]: Billing.Status;
  [ExportAllergies.Kind]: ExportAllergies.Status;
  [ExportAppointmentNote.Kind]: ExportAppointmentNote.Status;
  [ExportAppointmentStatus.Kind]: ExportAppointmentStatus.Status;
  [ExportAuthorizationForm.Kind]: ExportAuthorizationForm.Status;
  [ExportAuthorizationStart.Kind]: ExportAuthorizationStart.Status;
  [ExportAuthorizationStatus.Kind]: ExportAuthorizationStatus.Status;
  [ExportAuthorizationSubmission.Kind]: ExportAuthorizationSubmission.Status;
  [ExportCareGapFindings.Kind]: ExportCareGapFindings.Status;
  [ExportChargeReview.Kind]: ExportChargeReview.Status;
  [ExportClinicalComment.Kind]: ExportClinicalComment.Status;
  [ExportNewEncounter.Kind]: ExportNewEncounter.Status;
  [ExportEncounterInformation.Kind]: ExportEncounterInformation.Status;
  [ExportFamilyMedicalHistory.Kind]: ExportFamilyMedicalHistory.Status;
  [ExportFinancialResponsibility.Kind]: ExportFinancialResponsibility.Status;
  [ExportFollowUp.Kind]: ExportFollowUp.Status;
  [ExportForms.Kind]: ExportForms.Status;
  [ExportGeneralComment.Kind]: ExportGeneralComment.Status;
  [ExportGuarantor.Kind]: ExportGuarantor.Status;
  [ExportHccFindings.Kind]: ExportHccFindings.Status;
  [ExportMarkAsReviewed.Kind]: ExportMarkAsReviewed.Status;
  [ExportMedications.Kind]: ExportMedications.Status;
  [ExportNoteCheckedIn.Kind]: ExportNoteCheckedIn.Status;
  [ExportNoticeOfAdmission.Kind]: ExportNoticeOfAdmission.Status;
  [ExportNoticeOfAdmissionStatus.Kind]: ExportNoticeOfAdmissionStatus.Status;
  [ExportOrderRequestListStatus.Kind]: ExportOrderRequestListStatus.Status;
  [ExportPatientCareProviders.Kind]: ExportPatientCareProviders.Status;
  [ExportPatientInformation.Kind]: ExportPatientInformation.Status;
  [ExportPatientInsuranceInformation.Kind]: ExportPatientInformation.Status;
  [ExportPatientMedicalHistory.Kind]: ExportPatientMedicalHistory.Status;
  [ExportPatientPharmacies.Kind]: ExportPatientPharmacies.Status;
  [ExportPatientUploads.Kind]: ExportPatientUploads.Status;
  [ExportPatientUploadStatuses.Kind]: ExportPatientUploadStatuses.Status;
  [ExportPayorAuthorization.Kind]: ExportPayorAuthorization.Status;
  [ExportPreregistrationEncounter.Kind]: ExportPreregistrationEncounter.Status;
  [ExportProcessedPayments.Kind]: ExportProcessedPayments.Status;
  [ExportRegistrationNote.Kind]: ExportRegistrationNote.Status;
  [ExportScheduledAppointment.Kind]: ExportScheduledAppointment.Status;
  [ExportScheduledOrderAssociation.Kind]: ExportScheduledOrderAssociation.Status;
  [ExportSocialHistory.Kind]: ExportSocialHistory.Status;
  [ExportSurgicalHistory.Kind]: ExportSurgicalHistory.Status;
  [ExportTerminatedInsurances.Kind]: ExportTerminatedInsurances.Status;
  [ExportVerifyRegistration.Kind]: ExportVerifyRegistration.Status;
  [ExternalDocumentPacket.Kind]: ExternalDocumentPacket.Status;
  [ExternalOrderPacket.Kind]: ExternalOrderPacket.Status;
  [ExtractAuthorizationStatus.Kind]: ExtractAuthorizationStatus.Status;
  [ExtractMedicalNecessity.Kind]: ExtractMedicalNecessity.Status;
  [ExtractNoticeOfAdmissionStatus.Kind]: ExtractNoticeOfAdmissionStatus.Status;
  [ExtractPatientAdvisories.Kind]: ExtractPatientAdvisories.Status;
  [ExtractPatientAdvisoryDocuments.Kind]: ExtractPatientAdvisoryDocuments.Status;
  [ExtractPatientDocuments.Kind]: ExtractPatientDocuments.Status;
  [ExtractPatientEligibility.Kind]: ExtractPatientEligibility.Status;
  [ExtractPatientInsuranceRteInformation.Kind]: ExtractPatientInsuranceRteInformation.Status;
  [ExtractPatientOrder.Kind]: ExtractPatientOrder.Status;
  [Note.Kind]: Note.Status;
  [Order.Kind]: Order.Status;
  [Previsit.Kind]: Previsit.Status;
  [ProblemGroup.Kind]: ProblemGroup.Status;
  [QualityMeasure.Kind]: QualityMeasure.Status;
  [TrainingSegments.Kind]: TrainingSegments.Status;
}[TKind];

export const StatusValues: Status[] = [
  Billing.Status,
  Note.Status,
  ExportNoteCheckedIn.Status,
  Order.Status,
  Previsit.Status,
  ProblemGroup.Status,
  QualityMeasure.Status,
  TrainingSegments.Status,
].reduce<Status[]>((accum, statusEnum) => [...accum, ...Object.values(statusEnum)], []);

export interface KindAndStatusGroup {
  kind: Kind;
  status?: Status;
}

export interface FindAllOptions {
  startTime?: Date; // earliest workflow.created
  endTime?: Date; // latest workflow.created
  kindAndStatusGroups?: KindAndStatusGroup[];
  providerUserId?: string;
  practiceGroupId?: string;
  practiceId?: string;
  specialty?: string;
  assignedAnalystUserId?: string;
  encounterId?: string;
  encounterStartTimeBefore?: Date;
  encounterStartTimeAfter?: Date;
  limit?: number;
  ehrInformationId?: string;
  formSetCreatedTimeBefore?: Date;
  formSetCreatedTimeAfter?: Date;
}

interface BaseWorkflow<TKind extends Kind = Kind> {
  encounterId: string;
  kind: TKind;
  status: Status<TKind>;
  isCurrent: boolean;
  reasonsForReview: string[] | null;
  userId: string | null;
}
type BaseWorkflowV2<TKind extends Kind = Kind> = HasEntityIdPartial & {
  kind: TKind;
  status: Status<TKind>;
  reasonsForReview: string[] | null;
  userId: string | null;
  isCurrent: boolean;
};

export interface CreateValues<TKind extends Kind = Kind> extends Omit<
  BaseWorkflowV2<TKind>,
  'isCurrent' | 'reasonsForReview' | 'userId'
> {}

export interface Workflow<TKind extends Kind = Kind> extends BaseWorkflow<TKind>, BaseItem {}
export type WorkflowV2<TKind extends Kind = Kind> = BaseWorkflowV2<TKind> & BaseItem;

export type NoteWorkflow = Workflow<typeof Note.Kind>;
export type EncounterWorkflow = Workflow;

interface BaseDisplayableWorkflow<TKind extends Kind = Kind> extends Pick<
  BaseWorkflowV2<TKind>,
  'kind' | 'status' | 'reasonsForReview'
> {
  id: string;
  created: string;
  ehrInformationId: string;
  patientFirstName: string;
  patientLastName: string;
  practiceId: string;
}
type DisplayableEhrInformationWorkflow<TKind extends Kind = Kind> = BaseDisplayableWorkflow<TKind> &
  HasEhrInformationId;
type DisplayablePatientOrderWorkflow<TKind extends Kind = Kind> = BaseDisplayableWorkflow<TKind> &
  HasPatientOrderId & {
    specialty: string | null;
  };
type DisplayableEncounterWorkflow<TKind extends Kind = Kind> = BaseDisplayableWorkflow<TKind> &
  HasEncounterId & {
    assignedAnalystUserId: string | null;
    completedTimestamp: string | null;
    ehrReferenceValue: string | null;
    kindOfVisit: string | null;
    providerUserId: string;
    specialty: string;
  };
type DisplayableWorkflowOfKind<TKind extends Kind = Kind> = DisplayableEncounterWorkflow<TKind>;
type DisplayableWorkflowOfKindV2<TKind extends Kind = Kind> = Partial<
  DisplayableEncounterWorkflow<TKind> & HasEhrInformationId & HasPatientOrderId
> &
  (
    | DisplayableEhrInformationWorkflow<TKind>
    | DisplayablePatientOrderWorkflow<TKind>
    | DisplayableEncounterWorkflow<TKind>
  );

export type DisplayableExportNoteCheckedInWorkflow = DisplayableWorkflowOfKind<
  typeof ExportNoteCheckedIn.Kind
>;
export type DisplayableExportPatientUploadsWorkflow = DisplayableWorkflowOfKind<
  typeof ExportPatientUploads.Kind
>;
export type DisplayablePrevisitWorkflow = DisplayableWorkflowOfKindV2<typeof Previsit.Kind>;
export type DisplayableProblemGroupWorkflow = DisplayableWorkflowOfKind<typeof ProblemGroup.Kind>;

export type DisplayableWorkflow =
  | DisplayableExportNoteCheckedInWorkflow
  | DisplayableExportPatientUploadsWorkflow
  | DisplayablePrevisitWorkflow
  | DisplayableProblemGroupWorkflow;

export enum EntityKind {
  Encounter = 'ENCOUNTER',
  EhrInformation = 'EHR_INFORMATION',
  PatientOrder = 'PATIENT_ORDER',
}

export type ViewOptions = Partial<{
  entity: EntityKind;
  kinds: Kind[];
  status: string;
  failureReason: string;
  failureReasons: string[];
  after: Date;
  before: Date;
  practiceIds: string[];
  practiceGroupIds: string[];
  organizationIds: string[];
  page: number;
  limit: number;
  // entity specific
  payers: string[];
  encounterId: string;
  ehrInformationId: string;
  patientOrderId: string;
}>;

export type ViewWorkflow = WorkflowV2 & {
  ehrReferenceValue: string;
  startTime: Date;
  patientEhrId: string;
  organization: string;
  practiceGroup: string;
  practice: string;
  analystName: string;
};

export const VIEW_WORKFLOW_KINDS = [
  // exports
  ExportAllergies.Kind,
  ExportAppointmentNote.Kind,
  ExportAuthorizationForm.Kind,
  ExportAuthorizationStart.Kind,
  ExportAuthorizationStatus.Kind,
  ExportAuthorizationSubmission.Kind,
  ExportCareGapFindings.Kind,
  ExportChargeReview.Kind,
  ExportClinicalComment.Kind,
  ExportFamilyMedicalHistory.Kind,
  ExportFinancialResponsibility.Kind,
  ExportFollowUp.Kind,
  ExportForms.Kind,
  ExportGeneralComment.Kind,
  ExportMarkAsReviewed.Kind,
  ExportMedications.Kind,
  ExportNoteCheckedIn.Kind,
  ExportNoticeOfAdmissionStatus.Kind,
  ExportOrderRequestListStatus.Kind,
  ExportPatientCareProviders.Kind,
  ExportPatientInformation.Kind,
  ExportPatientInsuranceInformation.Kind,
  ExportPatientMedicalHistory.Kind,
  ExportPatientPharmacies.Kind,
  ExportPatientUploads.Kind,
  ExportPatientUploadStatuses.Kind,
  ExportPayorAuthorization.Kind,
  ExportPreregistrationEncounter.Kind,
  ExportProcessedPayments.Kind,
  ExportRegistrationNote.Kind,
  ExportScheduledAppointment.Kind,
  ExportScheduledOrderAssociation.Kind,
  ExportSocialHistory.Kind,
  ExportSurgicalHistory.Kind,
  ExportTerminatedInsurances.Kind,
  // special cased export workflow kinds that do not conform to usual naming conventions
  Billing.Kind,
  Note.Kind,
  Order.Kind,
  ProblemGroup.Kind,
  // extracts
  ExtractAuthorizationStatus.Kind,
  ExtractMedicalNecessity.Kind,
  ExtractPatientAdvisories.Kind,
  ExtractPatientAdvisoryDocuments.Kind,
  ExtractPatientEligibility.Kind,
  ExtractPatientInsuranceRteInformation.Kind,
  ExtractPatientOrder.Kind,
  ExtractPayorAuthorizationStatus.Kind, // DEPRECATED
];

export const WORKFLOW_KINDS_TO_RETRY: Kind[] = [
  ExportAllergies.Kind,
  ExportAppointmentNote.Kind,
  ExportAuthorizationForm.Kind,
  ExportAuthorizationStart.Kind,
  ExportAuthorizationStatus.Kind,
  ExportAuthorizationSubmission.Kind,
  ExportEncounterInformation.Kind,
  ExportNewEncounter.Kind,
  ExportFamilyMedicalHistory.Kind,
  ExportGeneralComment.Kind,
  ExportGuarantor.Kind,
  ExportMedications.Kind,
  ExportPatientCareProviders.Kind,
  ExportPatientInformation.Kind,
  ExportPatientPharmacies.Kind,
  ExportPayorAuthorization.Kind,
  ExportPreregistrationEncounter.Kind,
  ExportVerifyRegistration.Kind,
  ExtractAuthorizationStatus.Kind,
  ExtractMedicalNecessity.Kind,
  ExtractPatientAdvisoryDocuments.Kind,
  ExtractPatientOrder.Kind,
];
